const apiCache = new Map<string, { data: any; timestamp: number; ttl: number }>();
const CACHE_TTL = 5 * 60 * 1000; // 5 minutes

export function getCachedData(key: string): any | null {
  const cached = apiCache.get(key);
  if (cached && Date.now() - cached.timestamp < cached.ttl) {
    return cached.data;
  }
  if (cached) {
    apiCache.delete(key);
  }
  return null;
}

export function setCachedData(key: string, data: any, ttl = CACHE_TTL): void {
  apiCache.set(key, { data, timestamp: Date.now(), ttl });
}

export function clearApiCache(): void {
  apiCache.clear();
}
